import './headerBackground.scss';

export const HeaderBackground = angular
    .module('checkout.components.headerBackground', [])
    .component('headerBackground', {
        template: `
            <div
                class="header-background"
                ng-class="{'header-background--gradient': $ctrl.storeInfo.logo.imageLink.fullUri}">
                <ng-transclude></ng-transclude>
            </div>
        `,
        transclude: true,
        bindings: {
            storeInfo: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/headerBackground/headerBackground.js